<template>
  <v-container>
    <Member />
    <Progress />
    <Records />
  </v-container>
</template>
<script>
import Member from "@/components/history/Member"
import Progress from "@/components/history/Progress"
import Records from '../../components/history/Records.vue'

export default {
  name: "History",
    components: {
      Member,
      Progress,
      Records
  }
}
</script>